<a class="no-underline no-vertical-pad">
  @if (isLoaded) {
    <aggregate-card [aggregate]="aggregate" [aggregateCriteria]="aggregateCriteria" [chartConfiguration]="chartConfiguration" icon="monetization_on">
    </aggregate-card>
  }

  @if (!isLoaded) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</a>